import { IModelMapping } from "./generic/model.mapping";
import { AddressMapping } from "./address.mapping";
import { SavedContactMapping } from "./saved-contact.mapping";
import { LegacyInfoMapping } from "./customer-legacy-info.mapping";
import { LookUpTypeMapping } from "./lookup-type.mapping";
import { SavedAddressMapping } from "./saved-address.mapping";
import { ICustomerSummaryDtoModel } from "../models/customer/dto/customer-summary-dto.model";
import { ICustomerSummaryModel } from "../models/customer/customer-summary.model";
import { IJControlNewCustomerMessageDtoModel } from "../models/legacy-info/jcontrol-new-customer-message-dto.model";
import { GarageVehicleMapper } from "./garage-vehicle.mapping";

export class CustomerSummaryMapping implements IModelMapping<ICustomerSummaryDtoModel, ICustomerSummaryModel>  {

    private contactMapping: SavedContactMapping = new SavedContactMapping();
    private addressMapping: AddressMapping = new AddressMapping();
    private savedAddressMapping: SavedAddressMapping = new SavedAddressMapping();
    private legacyInfoMapping: LegacyInfoMapping = new LegacyInfoMapping();
    private lookUpTypeMapping: LookUpTypeMapping = new LookUpTypeMapping();
    private garageMapping: GarageVehicleMapper = new GarageVehicleMapper();
    
    toApplicationModel(model: ICustomerSummaryDtoModel): ICustomerSummaryModel {

        return {
            id: model.id,
            accountNumber: model.accountNumber,
            accountName: model.accountName,
            companyName: model.companyName,
            customerType: model.customerType ? this.lookUpTypeMapping.toApplicationModel(model.customerType) : undefined,
            customerGroup: model.customerGroup ? this.lookUpTypeMapping.toApplicationModel(model.customerGroup) : undefined,
            discountLevel: model.discountLevel ? this.lookUpTypeMapping.toApplicationModel(model.discountLevel) : undefined,
            accountStatus: model.accountStatus ? this.lookUpTypeMapping.toApplicationModel(model.accountStatus) : undefined,
            paymentMethod: model.paymentMethod ? this.lookUpTypeMapping.toApplicationModel(model.paymentMethod) : undefined,
            defaultShippingMethodId: model.defaultShippingMethodId ? model.defaultShippingMethodId : undefined,
            defaultContact: model.defaultContact ? this.contactMapping.toApplicationModel(model.defaultContact) : undefined,
            defaultAddress: model.defaultAddress ? this.savedAddressMapping.toApplicationModel(model.defaultAddress) : undefined,
            legacyInfo: model.legacyInfo ? this.legacyInfoMapping.toApplicationModel(model.legacyInfo) : undefined,
            internalComment: model.internalComment,
            defaultVehicle: model.defaultVehicle ? this.garageMapping.toApplicationModel(model.defaultVehicle) : undefined,
            isOnStop: model.isOnStop,
            defaultLanguage: model.defaultLanguage ? this.lookUpTypeMapping.toApplicationModel(model.defaultLanguage) : undefined,
        } as ICustomerSummaryModel

    }
    toDtoModel(model: ICustomerSummaryModel): ICustomerSummaryDtoModel {
        throw new Error("Method not implemented."); //we never need to post the summary data so don't need to map to a DTO
    }
    toDtoModels(models: ICustomerSummaryModel[]): ICustomerSummaryDtoModel[] {
        throw new Error("Method not implemented."); //we never need to post the summary data so don't need to map to a DTO
    }
    toApplicationModels(models: ICustomerSummaryDtoModel[]): ICustomerSummaryModel[] {
        return models.map(model => this.toApplicationModel(model));
    }

    toJControlNewCustomerMessageModel(model: ICustomerSummaryModel, type: string): IJControlNewCustomerMessageDtoModel {
        return {
            messageType: type,
            id: model.id,
            accountNumber: model.accountNumber,
            accountName: model.companyName ? model.companyName : model.accountName,
            accountStatus: model.accountStatus.code,
            billingAddress: this.addressMapping.toJControlAddressModel(model.defaultAddress),
            deliveryAddress: this.addressMapping.toJControlAddressModel(model.defaultAddress),
            telephoneNumber: model.defaultContact.telephoneNumber ? model.defaultContact.telephoneNumber : undefined, //todo mobile OR telephone is the rule, so can't rely on telephone being here
            emailAddress: model.defaultContact.emailAddress
        } as IJControlNewCustomerMessageDtoModel;
    }
}
